import { useSyncExternalStore } from "react";

/** W82 Web-6a-N1 (WN-20, Sichtung 66): große Schrift heißt Wurzelschrift ab 24 px (150 % der Grundschrift, DESIGN-W82 „ab 150 %
 *  gestapelt“; iOS `isAccessibilitySize`). Gelesen zur Laufzeit: sie folgt `--type-scale` und der Grundschrift des Browsers, die
 *  Media-Abfragen nicht sehen. Ein unsichtbarer Messpunkt (1rem breit, 0 hoch) meldet jede Änderung über `ResizeObserver`; ohne ihn
 *  (jsdom) gilt Standardschrift. */
const AB_PX = 24;
let gross = false;
const hoerer = new Set<() => void>();
let beobachter: ResizeObserver | null = null;

function lesen(): boolean {
  return parseFloat(getComputedStyle(document.documentElement).fontSize) >= AB_PX;
}

function abonnieren(hoeren: () => void): () => void {
  hoerer.add(hoeren);
  if (!beobachter && typeof ResizeObserver !== "undefined" && typeof document !== "undefined") {
    const punkt = document.createElement("span");
    punkt.setAttribute("aria-hidden", "true");
    punkt.dataset.schriftMesspunkt = "";
    punkt.style.cssText = "position:fixed;top:0;left:0;width:1rem;height:0;visibility:hidden;pointer-events:none";
    document.body.append(punkt);
    gross = lesen();
    beobachter = new ResizeObserver(() => {
      const neu = lesen();
      if (neu === gross) return;
      gross = neu;
      hoerer.forEach((h) => h());
    });
    beobachter.observe(punkt);
  }
  return () => hoerer.delete(hoeren);
}

/** true ab 150 % Schrift (Wurzelschrift ab 24 px), zur Laufzeit; in jsdom immer false */
export function useGrosseSchrift(): boolean {
  return useSyncExternalStore(
    abonnieren,
    () => (beobachter ? gross : false),
    () => false,
  );
}
